module.exports = __webpack_public_path__ + "static/img/13.f4065c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/sp/13.png
// module id = inuA
// module chunks = 0